import { selectChangeMessageForMenuItemReference } from '@UI/aside/asideMenuItemReference/asideMenuItemReferenceSelectors';
import { selectIsNodeReferenceValid } from '@newStore/validation/validationRules/externalLinkValidationRules';
import type { EditAsideMenuItemReference } from '@nodeTypeConfig/configTypes';

export const menuItemReference: EditAsideMenuItemReference = {
  component: 'menuItemReference',
  reactComponent: 'AsideMenuItemReference',
  asideChangeMessageSelector: selectChangeMessageForMenuItemReference,
  label: 'Navigeert naar',
  validations: [selectIsNodeReferenceValid],
};
